import { Component, OnInit, Input } from '@angular/core';
import { PedidoService } from 'src/app/service/pedido.service';
import { Helper } from 'src/app/shared/Helper';
import { Router } from '@angular/router';
import { Pedido } from "src/app/model/Pedido";

@Component({
  selector: 'app-consultar-pedido',
  templateUrl: './consultar-pedido.component.html',
  styleUrls: ['./consultar-pedido.component.css']
})
export class ConsultarPedidoComponent implements OnInit {

  @Input() Embarcado: boolean = false;
  @Input() ClienteId: string = "";

  public pageSize = 10;
  public currentPage = 0;
  public totalItems = 0;
  public carregando = false;

  public Historico: any;
  constructor(private pedidoService: PedidoService,
    private router: Router) { }

  ngOnInit() {
    if (!this.Embarcado) {
      this.ClienteId = Helper.getUserIdToken();
    }
    this.loadHistorico();
  }

  loadHistorico(page: number = 0, pageSize: number = 10) {
    this.carregando = true;
    this.pedidoService.HistoricoClientePaginated(this.ClienteId, page, pageSize).subscribe(hist => {
      this.Historico = hist.pedidos.map(p => {
        var ped = new Pedido();
        ped.Assing(p);
        return ped;
      });
      this.totalItems = hist.totalItems;
      this.carregando = false;
    });
  }
  
  changePage(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadHistorico(this.currentPage, this.pageSize);
  }

  public GoToHome() {
    this.router.navigate(['/']);
  }

  pad(num: number, size: number) {
    return Helper.pad(num, size);
  }

}
